import { PluginStateManager } from "../DataModel/PlugtinStateManager";
import { circleObject } from "../../../utils/utils";

/**
 * @description @FabricDiagram Plugin - it anchores to cell based plugins
 */
export class CircleDisplayPlugin extends PluginStateManager {
    fillStyle = "#256BDE";

    name = "Hexagon";

    anchordTypeTotal = false;

    constructor(options, ctx, data, state) {
        super(options, ctx, data, state);
    }

    /**
     * @description Draws the plugin
     */
    draw() {
        const pos = super.getPosition(); const
            size = super.getSize();
        const { x } = pos;
        const { y } = pos;
        const { width } = size;
        const style = { fillStyle: this.data.fillStyle || this.fillStyle };
        this.anchordTypeTotal = this.data && this.data.anchordTypeTotal ? this.data.anchordTypeTotal : false;
        style.strokeStyle = style.fillStyle;
        if (this.state.selected) style.strokeStyle = "red";
        if (Number.isInteger(this.data.text) && this.data.text) {
            circleObject(x, y, width, this.data, this.ctx);
            if (Number.isInteger(this.data.text)) {
                this.ctx.fillStyle = this.data.textColor ? this.data.textColor : "#ffffff";
                this.ctx.fillText(this.data.text, this.position.x, this.position.y - this.size.width / 3);
            }
        }
    }

    /**
     * @description - checks to see if the provided point is inside the plugin area
     * @param {Object} point  - coordonates
     * @returns {boolean}
     */
    pointInElement(point) {
        return this.isPointIn(point);
    }

    /**
     * @description - checks to see if the provided point is inside the plugin area
     * @param {Object} point  - coordonates
     * @returns {boolean}
     */
    isPointIn(point) {
        const r = super.getSize().width; const s = 6; const cx = super.getPosition().x; const cy = super.getPosition().y;
        const mx = point.x; const
            my = point.y;
        const m = r * Math.cos(Math.PI / s);
        const d = Math.hypot(mx - cx, my - cy);
        const a = Math.atan2(cy - my, mx - cx);
        return d <= (r + m) / 2 + Math.cos(a * s) * (r - m) / 2;
    }

    /**
     * @description Updates the state of the plugin
     * @param {Object} options  - { size, position} object
     * @param {Object} state - state object to update the plugin state
     * @param {Object} data - data object to update the plugin data
     */
    update(options, state, data) {
        this.setPosition(options && options.position ? options.position : super.getPosition());
        this.setSize(options && options.size ? options.size : super.getSize());
        if (state) this.updateState(state);
        if (data) this.setData({ ...this.getData(), ...data });
    }
}
